/**** mgt.Trip_Stops */
import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: 'mgt',
  table: 'Trip_Stops',
  title: 'Последовательность остановок в рейсах',
  apiType: apiTypes.DEFAULT,
  elemsOnPage: 100,
  connections: {
    stop: {
      apiType: apiTypes.DEFAULT,
      schema: 'mgt',
      table: 'Stops',
      index: 'stop_id',
      fields: ['stop_name'],
      format: (elem: any) => elem['stop_name'],
      autocomplete: true,
    },
    trip: {
      apiType: apiTypes.DEFAULT,
      schema: 'mgt',
      table: 'Trip',
      index: 'id',
      customsql:
        `SELECT tr.id, rt.route_short_name, tr.race_type  FROM mgt."Trip" tr
          INNER JOIN mgt."MarshVariants" vr ON tr."MarshVariant_id"=vr.id
          INNER JOIN mgt."Routes" rt ON vr.route_id = rt.route_id`,
      fields: ['route_short_name', 'race_type'],
      format: (elem: any) =>
        `${elem['route_short_name']} - ${elem['race_type']}`,
      autocomplete: true,
    },
  },
  fields: [
    {
      name: 'id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
    },
    {
      name: 'trip_id',
      title: 'Рейс',
      type: 'number',
      required: true,
      connection: 'trip',
    },
    {
      name: 'stop_id',
      title: 'Остановка',
      type: 'number',
      required: true,
      connection: 'stop',
    },
    {
      name: 'stop_sequence',
      title: 'Порядковый номер ОП в рейсе',
      type: 'number',
      required: true,
    },
    {
      name: 'kkp',
      title: 'Признак конечной остановки',
      type: 'list',
      required: false,
      values: [
        { key: null, value: '' },
        { key: 'B', value: 'Начало рейса' },
        { key: 'E', value: 'Конец рейса' },
      ],
    },
    {
      name: 'do_not_update',
      title: 'Отключить автообновление',
      type: 'boolean',
      required: false,
      width: '205px',
    }
  ],
  newTemplate: {
    id: null,
    trip_id: null,
    stop_id: null,
    stop_sequence: null,
    kkp: null,
    do_not_update: true,
  },
  // createField: 'createdAt',
  updateField: 'update_date',
  defaultSort: {
    field: 'id',
    direction: 'desc',
  },
  import: {
    header: [
      {
        title: 'trip_id',
        field: 'trip_id',
      },{
        title: 'stop_id',
        field: 'stop_id',
      },{
        title: 'stop_num',
        field: 'stop_sequence',
      },{
        title: 'kkp',
        field: 'kkp',
      }
    ],
    example: `1;1;1;B`,
  },
  export: {
    connections: {
      routes:   {
        index: 'trip_id',
        customsql:
          `SELECT t1.route_short_name, t3.id as trip_id
           FROM mgt."Routes" t1
           INNER JOIN mgt."MarshVariants" t2 ON t1.route_id = t2.route_id
           INNER JOIN mgt."Trip" t3 ON t2.id = t3."MarshVariant_id"`,
      },
      vehicles: {
        index: 'trip_id',
        customsql:
          `SELECT t1.route_type, t6.id as trip_id
           FROM mgt."Vehicle" t1
           INNER JOIN mgt."Depot" t2 ON t1.depot_id = t2.depot_id
           INNER JOIN mgt."Agency" t3 ON t2.agency_id = t3.agency_id
           INNER JOIN mgt."Routes" t4 ON t3.agency_id = t4."Agency_id"
           INNER JOIN mgt."MarshVariants" t5 ON t4.route_id = t5.route_id
           INNER JOIN mgt."Trip" t6 ON t5.id = t6."MarshVariant_id"`,
      },
    },
    fields:      [
      {
        name:               'trip_id',
        title:              'Рейс',
        connectionGetField: {
          fields: ['route_short_name', 'race_type'],
          template: '%1 - %2',
        },
      },
      {
        name:             'route_name',
        title:            'Маршрут',
        connection:       'routes',
        connectionKey:    'trip_id',
        connectionGetField: 'route_short_name',
      },
      {
        name:             'route_type',
        title:            'Тип ТС',
        connection:       'vehicles',
        connectionKey:    'trip_id',
        connectionGetField: 'route_type',
      },
      {
        name:               'stop_id',
        title:              'Остановка',
        connectionGetField: 'stop_name',
      },
      {
        name:  'stop_sequence',
        title: 'Порядковый номер ОП в рейсе',
      },
      {
        name:  'kkp',
        title: 'Признак конечной остановки',
        format: {
          fields: ['kkp'],
          template: '%1',
          values: {
            'null': '',
            'B': 'Начало рейса',
            'E': 'Конец рейса'
          }
        }
      },
    ],
  }
};

export default config;
